export const GET_PROFILE = 'GET_PROFILE';
export const GET_PROFILE_SUCCESS = 'GET_PROFILE_SUCCESS';
export const GET_PROFILE_FAILURE = 'GET_PROFILE_FAILURE';
export const UPDATE_PROFILE_INFO = 'UPDATE_PROFILE_INFO';
export const UPDATE_PROFILE_INFO_SUCCESS = 'UPDATE_PROFILE_INFO_SUCCESS';
export const UPDATE_PROFILE_INFO_FAILURE = 'UPDATE_PROFILE_INFO_FAILURE';
export const UPDATE_PROFILE_INFO_RESET = 'UPDATE_PROFILE_INFO_RESET';
export const USER_DETAILS = 'USER_DETAILS';
